import type { ReactNode } from 'react';
import styles from './button.module.css';

type Props = {
  children: ReactNode;
  onClick?: () => void;
  href?: string;
  target?: string;
  rel?: string;
};

export function Button(props: Props) {
  const { children, onClick, href, target, rel } = props;
  if (href) {
    return (
      <a className={styles.root} onClick={onClick} href={href} target={target} rel={rel}>
        {children}
      </a>
    );
  }

  return (
    <button className={styles.root} onClick={onClick}>
      {children}
    </button>
  );
}
